// ========================================
// Start Sticky cart
// ========================================
class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.button_id = this.dataset.button;
    this.button_original = null;
    this.btn_item = null;
    this.observer = null;
    this.quantity_input = document.querySelector('.price-per-item__container quantity-input [name="quantity"]');
    this.sticky_quantity_input = this.querySelector('.form-field-input');
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.button_original = document.querySelector(this.button_id);
    if (!this.button_original) return;
    this.btn_item = this.querySelector('button.button.button--primary');
    if (!this.btn_item) return;
    this.syncQuantity();
    this.btn_item.addEventListener('click', () => {
      if (this.quantity_input && Number(this.quantity_input.value) > 0) {
        this.button_original.click();
      } else if (this.quantity_input) {
        this.quantity_input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        this.quantity_input.focus();
      }
    });
    if(this.sticky_quantity_input) {
      this.sticky_quantity_input.addEventListener('click', () => {
        this.quantity_input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        this.quantity_input.focus();
      });
      this.quantity_input.addEventListener('input', () => {
        this.syncQuantity();
      });
      this.quantity_input.addEventListener('change', () => {
        this.syncQuantity();
      });
    }
    this.createObserver();
  }
  syncQuantity() {
    if (!this.quantity_input || !this.sticky_quantity_input) return;
    this.sticky_quantity_input.value = this.quantity_input.value;
  }
  createObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            this.classList.add('visible');
          } else {
            this.classList.remove('visible');
          }
        });
      },
      {
        root: null,
        threshold: 0
      }
    );
    this.observer.observe(this.button_original);
  }
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
customElements.define('sticky-add-to-cart-custom', StickyAddCart);
// ========================================
// Finish Sticky cart
// ========================================